import React from 'react';
import OptionButton from '../shared/OptionButton';
import { TrainingIntensityPreference } from '../../../types/enums';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const options = [
  { label: 'I prefer easy runs (no hard sessions)', value: TrainingIntensityPreference.LOW },
  { label: 'One challenging session per week (intervals or tempo runs)', value: TrainingIntensityPreference.MEDIUM },
  { label: 'Two challenging sessions per week (intervals or tempo runs)', value: TrainingIntensityPreference.HIGH },
];

const TrainingIntensityStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {options.map((opt) => (
        <OptionButton
          key={opt.value}
          label={opt.label}
          value={opt.value}
          selected={answer === opt.value}
          onClick={onAnswer}
        />
      ))}
    </div>
  );
};

export default TrainingIntensityStep;
